import { IconButton, SxProps, Theme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import React from 'react';

export type HamburgerMenuIconProps = {
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    sx: SxProps<Theme>;
};

const HamburgerMenuIcon = ({ onClick, sx }: HamburgerMenuIconProps) => {
    return (
        <IconButton onClick={onClick} sx={{ height: 30, ...sx }}>
            <MenuIcon sx={{ color: 'white' }} />
        </IconButton>
    );
};

export default HamburgerMenuIcon;
